/*
 * 72px halo + 56px solid disc, as measured from the mock-ups.
 */
export function SuccessIcon() {
  return (
    <svg width="72" height="72" viewBox="0 0 72 72" fill="none" aria-hidden="true">
      <circle cx="36" cy="36" r="36" fill="var(--success-tint)"/>
      <circle cx="36" cy="36" r="28" fill="var(--success)"/>
      <path
        d="M24.5 36.5 32.5 44.5 47.5 29.5"
        stroke="#FFFFFF"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function FailedIcon() {
  return (
    <svg width="72" height="72" viewBox="0 0 72 72" fill="none" aria-hidden="true">
      <circle cx="36" cy="36" r="36" fill="var(--danger-tint)"/>
      <circle cx="36" cy="36" r="28" fill="var(--danger)"/>
      <path
        d="M28 28 44 44M44 28 28 44"
        stroke="#FFFFFF"
        strokeWidth="4"
        strokeLinecap="round"
      />
    </svg>
  )
}
